export const ADD_CUSTOMER_DATA = 'ADD_CUSTOMER_DATA';

export default function reducer(state = {}, action) {
  switch (action.type) {
    case ADD_CUSTOMER_DATA:
      return {
        ...action.payload,
      };
    default:
      return state;
  }
}
